// extracted by mini-css-extract-plugin
module.exports = {"QuizCreator":"QuizCreator__QuizCreator___2r9Te","rainbow":"QuizCreator__rainbow___3t-D3"};